import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import { AddNoteButton } from 'reservations/form/components/AddNoteButton';
import HookFormTextField from 'reservations/form/components/HookFormTextField';

const NOTES_PLACEHOLDER =
  'Please be aware that special requests are not guaranteed';

function NotesFormField() {
  const note = useWatch({
    name: 'note'
  });
  const [isNoteOpen, setIsNoteOpen] = useState(!!note);

  return (
    <>
      {!isNoteOpen ? (
        <AddNoteButton onClick={() => setIsNoteOpen(true)} />
      ) : (
        <HookFormTextField
          multiline
          name="note"
          label="Notes"
          rows={2}
          placeholder={NOTES_PLACEHOLDER}
        />
      )}
    </>
  );
}

export default NotesFormField;
